import { render } from "./Maindetails.vue?vue&type=template&id=c31c1d94&scoped=true"
import script from "./Maindetails.vue?vue&type=script&lang=js"
export * from "./Maindetails.vue?vue&type=script&lang=js"

import "./Maindetails.vue?vue&type=style&index=0&id=c31c1d94&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31c1d94"]])

export default __exports__